import PropTypes from 'prop-types'

import idPropType from './id-prop-type'

const eventPropType = PropTypes.shape({
  id: idPropType.isRequired,
  entityType: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  sessionId: PropTypes.string.isRequired,
  subtype: PropTypes.string,
  bulkOperationId: PropTypes.string,
  entityId: idPropType,
  source: PropTypes.string,
  original: PropTypes.object,
  changes: PropTypes.object,
  createdAt: PropTypes.string.isRequired,
  createdBy: PropTypes.shape({
    id: idPropType.isRequired,
    name: PropTypes.string.isRequired,
  }),
})

export default eventPropType
